<div mat-dialog-title>
  <div i18n>Настройка столбцов</div>
  <button mat-button class="mat-icon-button" mat-dialog-close aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="no-padding">
  <table class="simple fields-table">
    <thead>
      <tr>
        <th></th>
        <th i18n>Название</th>
        <th i18n>Отображение</th>
      </tr>
    </thead>
    <tbody cdkDropList [cdkDropListData]="fields" (cdkDropListDropped)="drop($event)">
      <tr cdkDrag *ngFor="let item of fields" class="row" [cdkDragData]="item">
        <td class="column-order">
          <mat-icon class="handle" cdkDragHandle> drag_handle </mat-icon>
        </td>

        <td i18n *ngIf="item.name === 'dateCreate'">Дата</td>
        <td i18n *ngIf="item.name === 'name'">Название</td>
        <td i18n *ngIf="item.name === 'factoryOrderId'">Производственный номер</td>
        <td i18n *ngIf="item.name === 'statusName'">Статус</td>
        <td i18n *ngIf="item.name === 'amount'">Сумма</td>
        <td i18n *ngIf="item.name === 'dateEdit'">Дата изменения</td>
        <td i18n *ngIf="item.name === 'note'">Примечание</td>
        <td i18n *ngIf="item.name === 'clientNote'">Внутренний комментарий</td>
        <td i18n *ngIf="item.name === 'dateOfIssue'">Дата выдачи</td>
        <td i18n *ngIf="item.name === 'plannedDateOfIssue'">Планируемая дата выдачи</td>
        <td i18n *ngIf="item.name === 'menu'">Настройки</td>

        <td class="column-show">
          <mat-checkbox [disabled]="item.name === 'menu'" [(ngModel)]="item.visible"> </mat-checkbox>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div mat-dialog-actions>
  <button i18n mat-raised-button type="button" class="mat-accent mr-4" [mat-dialog-close]="fields">ОК</button>
  <button i18n mat-button mat-dialog-close>ОТМЕНА</button>
</div>
